import PropTypes from 'prop-types';
import React from 'react';

// NOTE: Using a class-based component here because the error boundary feature
// is only available in class components
class ProgressBarErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

ProgressBarErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ProgressBarErrorBoundary;
